export const ButtonType = {
    PLUS:0,
    ARROW: 1,

}

export const FontSizeByIndex = {
    popup: {
    desktop: { 
     0: '32px',
     1: '20px',
     2:'20px',//just one element
    }, 
    mobile: {
     0: '24px',
     1: '20px',
     2:'20px',//just one element  
    }

   },
   notPopup: {
     desktop: {
     0: '36px',
     1: '22px',
     2:'24px',//just one element
    },
    mobile: {
     0: '20px',
     1: '16px',
     2:'20px',//just one element
    }
  }};

